const registerMetric = (webVitals, names, onPerfEntry) => {
  const metricHandler = names
    .map((name) => webVitals[name])
    .find((handler) => typeof handler === 'function');
  if (metricHandler) {
    metricHandler(onPerfEntry);
  }
};

export const registerWebVitals = (webVitals, onPerfEntry) => {
  registerMetric(webVitals, ['onCLS', 'getCLS'], onPerfEntry);
  registerMetric(webVitals, ['onFCP', 'getFCP'], onPerfEntry);
  registerMetric(webVitals, ['onINP', 'getINP'], onPerfEntry);
  registerMetric(webVitals, ['onLCP', 'getLCP'], onPerfEntry);
  registerMetric(webVitals, ['onTTFB', 'getTTFB'], onPerfEntry);
  registerMetric(webVitals, ['onFID', 'getFID'], onPerfEntry);
};

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => registerWebVitals(webVitals, onPerfEntry));
  }
};

export default reportWebVitals;
